<template>
  <div class="mb-servicio__select-container relative">
    <button
      type="button"
      class="block py-4 text-left border-b border-gray-300 bg-transparent dark:border-gray-700 dark:text-gray-200"
      data-testid="cambiar-servicio"
      aria-haspopup="listbox"
      :aria-expanded="state.show"
      aria-controls="servicio-listbox"
      @click="state.show = !state.show"
    >
      <span class="text-xl leading-none flex items-center">
        <span class="mr-4">{{ servicioName }}</span>
        <LucideChevronDown
          :size="24"
          aria-hidden="true"
          :class="[
            state.show && 'rotate-180',
            'transition-all stroke-current text-orange',
          ]"
        />
      </span>
    </button>

    <Transition name="slide-open">
      <ul
        id="servicio-listbox"
        v-show="state.show"
        role="listbox"
        class="min-h-122 bg-white overflow-y-auto border border-gray-200 shadow absolute z-10 w-full min-w-190 max-w-[calc(100vw-(var(--spacing)*16*2))] left-0 top-full dark:bg-gray-900 dark:border-gray-700"
      >
        <li
          v-for="(serv, servI) in listaServicios"
          hydrate-on-visible
          :key="serv._id"
          role="option"
          :aria-selected="serv.destacado"
          class="flex items-center border-b border-gray-200 dark:border-gray-700"
          :style="{ '--i': servI }"
        >
          <button
            type="button"
            class="flex-1 p-8 text-left"
            @click="cambiarServicio(serv)"
            :data-testid="`select-servicio_${serv.slug}`"
          >
            {{ serv.name }}
          </button>
          <button
            type="button"
            class="p-8 text-left"
            :aria-label="
              serv.destacado ? 'Quitar destacado' : 'Destacar servicio'
            "
            @click="starServicio(serv)"
          >
            <LucideArrowRight :size="16" aria-hidden="true" />
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { BASE_SERVICIO_SLUG } from '~~/constants';
import type { IServicio } from '~~/interfaces';

type ServicioDestacado = IServicio & { destacado?: boolean };

const props = withDefaults(
  defineProps<{
    servicios: Map<string, ServicioDestacado>;
    servicioBase?: string;
  }>(),
  {
    servicioBase: BASE_SERVICIO_SLUG,
  }
);

const state = reactive({
  show: false,
});

const servicio = computed(() => props.servicios.get(props.servicioBase));
const servicioName = computed(() => servicio.value?.name);

const listaServicios = computed(() =>
  Array.from(props.servicios.values()).map((srv) =>
    Object.assign({}, srv, {
      destacado: String(props.servicioBase) === String(srv.slug),
    })
  )
);

const emit = defineEmits(['star', 'servicio']);

const starServicio = (est: IServicio) => emit('star', est);
const cambiarServicio = (srv: IServicio) => emit('servicio', srv);
</script>

<style scoped>
.slide-open-enter-active,
.slide-open-leave-active {
  transition: height 0.2s ease-in-out;
  will-change: height;
}
.slide-open-enter-from,
.slide-open-leave-to {
  height: 0;
}
.slide-open-enter-active li,
.slide-open-leave-active li {
  transition: all 0.2s ease-in-out;
  transition-delay: calc(var(--i) * 0.055s);
  /* will-change: opacity,transform; */
}
.slide-open-enter-from li,
.slide-open-leave-to li {
  opacity: 0;
  transform: translateY(-50%);
}
</style>
